import styled from '@emotion/styled';
import { boxSizes, colors, fontSizes, fontWeights, gutterSizes, lineHeights } from '../base/theme';

export const DetailExpandableItemWrapper = styled.div`
    border-bottom: 1px solid ${colors.bark10};
    padding: ${gutterSizes.large} 0;
`;

export const ItemHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
`;

export const ItemTitle = styled.h4`
    margin: 0;
    font-size: ${fontSizes.base};
    font-weight: ${fontWeights.lightBold};
    color: ${colors.bark};
    flex: 1;
`;

export const ExpandIcon = styled.div<{ isExpanded: boolean }>`
    display: flex;
    align-items: center;
    transition: transform 0.2s ease;
    background-color: ${colors.branch5};
    padding: ${gutterSizes.base};
    border-radius: ${boxSizes.borderRadius4};
    
    .icon {
        font-size: ${fontSizes.medium};
    }
`;

export const ItemContent = styled.div`
    padding: ${gutterSizes.base} 0;
    color: ${colors.bark};
    line-height: ${lineHeights.base};
`;
